import styled from '../../../../../theme'
import { IWithSize } from '../../../../BookingCalendar/Calendar/Calendar'

const ButtonLabel = styled.div<IWithSize>`
  font-family: 'Open Sans', sans-serif;
  font-size: ${({ size }) => (size ? 16 * size : 16)}px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.2px;
  text-align: center;
`

export default ButtonLabel
